import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpXsrfTokenExtractor,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class TokenAuth implements HttpInterceptor {

  cookieService = inject(CookieService);

  constructor(
    private router: Router,
    private cookieExtractor: HttpXsrfTokenExtractor,
    public authService: AuthService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Always send cookies to backend
    request = request.clone({ withCredentials: true });

    // Get clean JWT from AuthService
    const token = this.authService.getToken();

    // Add Authorization header
    if (token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event),

      catchError((error: HttpErrorResponse) => {
        console.log("Interceptor Error:", error.error);

        // Auto logout for invalid session
        if (
          error.status === 401 &&
          (error.error?.message === 'Cookie is not present.' ||
           error.error?.message === 'Invalid session ID')
        ) {
          localStorage.clear();
          this.cookieService.delete('vicas_token');
          this.router.navigate(['auth/login']);
        }

        return throwError(() => error);
      })
    );
  }
}
